// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}
.loader .dot {
  width: 8px;
  height: 8px;
  background: #ccc; /* rgb(82, 173, 255); */
  border-radius: 50%;
  margin: 0 4px !important;
}

.loader .dot1 {
  left: 0px;
  -webkit-animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.1, 0.28) alternate infinite;
  animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.1, 0.28) alternate infinite;
}

.loader .dot2 {
  left: 20px;
  -webkit-animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.1, 0.28) alternate infinite;
  animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.1, 0.28) alternate infinite;
}

.loader .dot3 {
  left: 40px;
  -webkit-animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.1, 0.28) alternate infinite;
  animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.1, 0.28) alternate infinite;
}

@-webkit-keyframes dot-jump {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-12px);
    transform: translateY(-12px);
  }
}

@keyframes dot-jump {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-12px);
    transform: translateY(-12px);
  }
}
`, "",{"version":3,"sources":["webpack://./app/css/Loader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB,EAAE,uBAAuB;EACzC,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,uFAAuF;EACvF,+EAA+E;AACjF;;AAEA;EACE,UAAU;EACV,4FAA4F;EAC5F,oFAAoF;AACtF;;AAEA;EACE,UAAU;EACV,4FAA4F;EAC5F,oFAAoF;AACtF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;EACA;IACE,oCAAoC;IACpC,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;EACA;IACE,oCAAoC;IACpC,4BAA4B;EAC9B;AACF","sourcesContent":[".loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n}\n.loader .dot {\n  width: 8px;\n  height: 8px;\n  background: #ccc; /* rgb(82, 173, 255); */\n  border-radius: 50%;\n  margin: 0 4px !important;\n}\n\n.loader .dot1 {\n  left: 0px;\n  -webkit-animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.1, 0.28) alternate infinite;\n  animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.1, 0.28) alternate infinite;\n}\n\n.loader .dot2 {\n  left: 20px;\n  -webkit-animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.1, 0.28) alternate infinite;\n  animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.1, 0.28) alternate infinite;\n}\n\n.loader .dot3 {\n  left: 40px;\n  -webkit-animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.1, 0.28) alternate infinite;\n  animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.1, 0.28) alternate infinite;\n}\n\n@-webkit-keyframes dot-jump {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n  100% {\n    -webkit-transform: translateY(-12px);\n    transform: translateY(-12px);\n  }\n}\n\n@keyframes dot-jump {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n  100% {\n    -webkit-transform: translateY(-12px);\n    transform: translateY(-12px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
